import React, { FormEvent, ReactNode } from 'react';
import { Root, TightRoot } from './group.styles';

export interface GroupProps {
    children?: ReactNode;
    maxWidth?: string;
    minWidth?: string;
    width?: string;
    flex?: boolean;
    tight?: boolean;
    stopPropagation?: boolean;
    verticalPadding?: string;
    /** @deprecated Use verticalPadding instead */
    verticalMargin?: string;
    divider?: boolean;
    justify?: string;
    align?: string;
    noMargin?: boolean;
    form?: boolean;
    onSubmit?: (e: FormEvent) => void;
}

export function Group({
    children,
    maxWidth,
    minWidth,
    width,
    flex = false,
    tight = false,
    stopPropagation = false,
    verticalPadding,
    verticalMargin,
    divider = false,
    justify = '',
    align = '',
    noMargin,
    form = false,
    onSubmit,
}: GroupProps) {
    // Cast the chosen component so that TypeScript accepts polymorphic "as" prop.
    const RootComponent = (tight ? TightRoot : Root) as React.ComponentType<any>;
    const elementType = form ? 'form' : 'div';
    // Support deprecated verticalMargin prop
    const effectiveVerticalPadding = verticalPadding || verticalMargin;
    return (
        <RootComponent
            as={elementType}
            data-group
            onClick={stopPropagation ? (e: any) => e.stopPropagation() : undefined}
            onSubmit={onSubmit}
            $align={align}
            $divider={divider}
            $flex={flex}
            $justify={justify}
            $maxWidth={maxWidth}
            $minWidth={minWidth}
            $noMargin={noMargin}
            $tight={tight}
            $verticalPadding={effectiveVerticalPadding}
            $width={width}
        >
            {children}
        </RootComponent>
    );
}
